import styled, { keyframes } from 'styled-components'
import { m as motion } from 'framer-motion'
import { Section } from './globalStyles'
import { media } from './globalStyles'

const jump = keyframes`
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0);
  }
`

export const IntroSection = styled(Section)`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  ${media.lessThan('phone')`
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
  `};
`

export const LogoWrapper = styled.div`
  position: relative;
  width: 36.896%;
  height: 0;
  padding-top: 15.8125%;
  ${media.lessThan('tablet')`
    width: 67.5781%;
    padding-top: 28.9062%;
  `};
  ${media.lessThan('phone')`
    width: 86.2304%;
    padding-top: 36.8164%;
    margin-right: 1.25rem;
  `};
`

export const LogoTagWrapper = styled(motion.div)`
  position: absolute;
  width: 33.7301%;
  top: 65%;
  right: 0;
`

export const Tagline = styled(motion.h3)`
  display: block;
  padding-left: 2.5%;
  font-size: 1.5rem;
  line-height: 1.8125rem;
  text-align: center;
  color: ${(props) => props.theme.textGray};
  ${media.lessThan('phone')`
    padding: 0 10%;
  `};
`

export const ScrollDownBtn = styled(motion.button)`
  position: absolute;
  box-sizing: initial;
  width: 3rem;
  height: 3rem;
  bottom: 2rem;
  z-index: 2;
  ${media.lessThan('phone')`
    bottom: 1.5rem;
  `}
  svg {
    width: 1.5625rem;
    fill: ${(props) => props.theme.blue};
    transform: translateZ(0) scale(1.0, 1.0);
    ${media.greaterThan('phone')`
      transition-property: fill;
      will-change: fill;
    `}
  }
  ${media.greaterThan('phone')`
    &:hover {
      svg {
        fill: ${(props) => props.theme.orange};
        animation: ${jump} 1s linear infinite;
      }
    }
  `}
`
